import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/authContext";

const RoleCheck = () => {
  const { userData } = useAuth();
  // console.log(userData, "userData");

  if (userData.role === "admin" || userData.role === "super_admin")
    return <Outlet />;
  else return <Navigate to="/unauthorized" replace />;

  //   return <div>RoleCheck</div>;
};
export default RoleCheck;
